import exportimages from "../../../assets/images/exportImages";
import { EWI_NOTIFICATION_STATUS } from "../../../utils/global";
import { InsightsTourContent } from "./TourContent";

export const getInsightsTourSteps = (
  ewiNotificationStatus,
  idrssd,
  onClose,
) => {
  switch (ewiNotificationStatus) {
    case EWI_NOTIFICATION_STATUS.EXIST:
      return [
        {
          target: ".insights-tour-target",
          placement: "bottom",
          disableBeacon: true,
          content: (
            <InsightsTourContent
              image={exportimages?.insights_exist_popup_img}
              title="Good news! Your personalized Insights are now available"
              description="We’ve analyzed your institution’s data and prepared customized risk alerts and key insights for you to explore"
              ewi_status={EWI_NOTIFICATION_STATUS.EXIST}
              idrssd={idrssd}
              onClose={onClose}
            />
          ),
        },
      ];

    case EWI_NOTIFICATION_STATUS.NOT_EXIST:
      return [
        {
          target: ".insights-tour-target",
          placement: "bottom",
          disableBeacon: true,
          content: (
            <InsightsTourContent
              image={exportimages?.insights_exist_popup_img}
              title="We are Cooking"
              description="Your personalized Insights are currently being calculated and will be available within 2 business days."
              ewi_status={EWI_NOTIFICATION_STATUS.NOT_EXIST}
              idrssd={idrssd}
              onClose={onClose}
            />
          ),
        },
      ];

    default:
      return [];
  }
};
